import { FC } from 'react';
import { themeColors, themeSizes } from '../../../styles/globalStyleVars';
import styled from 'styled-components';
import { AlertsDrawerEmptyState } from './AlertsDrawerEmptyState';
import FetchError from '../FetchError';
import { PageLoader as CorePageLoader } from '@cfa/react-core';

interface Props {
  childCasesLoading: boolean;
  loadingError: boolean;
  minorCasesLoading: boolean;
  handleErrorRefetch: () => void;
}

const LoadingOverlayContainer = styled.div<{ $showOverlay: boolean }>`
  display: ${({ $showOverlay }) => ($showOverlay ? 'flex' : 'none')};
  position: absolute;
  background-color: ${themeColors.primaryWhite};
  height: 100%;
  width: 100%;
  justify-content: center;
  align-self: center;
`;

export const LoadingOverlay: FC<Props> = ({
  childCasesLoading,
  minorCasesLoading,
  loadingError,
  handleErrorRefetch,
}) => (
  <LoadingOverlayContainer
    $showOverlay={childCasesLoading || loadingError || minorCasesLoading}
  >
    {childCasesLoading ? (
      <AlertsDrawerEmptyState heading='Working on that...' showLoadingSpinner />
    ) : (
      <>
        {loadingError && (
          <div>
            <FetchError
              btnClick={handleErrorRefetch}
              errorType='modal-fetch'
              page='alerts-drawer'
            />
          </div>
        )}
        {minorCasesLoading && (
          <div style={{ display: 'block' }}>
            <CorePageLoader style={{ margin: `${themeSizes.xxl} auto` }} />
          </div>
        )}
      </>
    )}
  </LoadingOverlayContainer>
);
